import React from 'react';

import { useState, useEffect } from "react";
import { Container, Nav } from 'react-bootstrap';
import { Outlet, NavLink } from "react-router-dom";

const Layout = () => {
    const [categoryList, setCategoryList] = useState([]);

    useEffect( () => {
        const fetchCategories = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BACKEND_API}/categories`, {
                    method: "GET",
                    mode: 'cors'
                });
                const data = await response.json();
                setCategoryList(data.data);
                
            } catch (error) {
                console.log(error);
            }
        };

        fetchCategories();
        window.history.replaceState({}, document.title);
    }, []);

    return (
        <>
            <header>
                <Nav.Item>
                    <Container fluid>
                        <Nav className="nav-menu mobile-menu">
                            <li key="0"><NavLink to="/" className={({ isActive }) => (isActive ? "activeMenu" : null)}>Home</NavLink></li>
                            {categoryList.map((category) => (
                                <li key={category.id}><NavLink to={'/' + category.path} className={({ isActive }) => (isActive ? "activeMenu" : null)}>{category.name}</NavLink></li>        
                            ))}
                        </Nav>
                        <div id="mobile-menu-wrap"></div>
                    </Container>
                </Nav.Item>
            </header>

            <Outlet />
        </>
    );
}

export default Layout;